import API from "..";
import { checkAPIAvailability } from "../helpers";

export default class Tradename {
  /**
   * The Sample dimension table for M3
   * @param {String} tradenameName The MIDAS of the Sample
   */
  constructor({
    id,
    tradenameName,
    chemID,
    substanceName,
    referenceSubstance,
    createdByEmail,
    createdDate,
    lastModifiedByEmail,
    lastModifiedDate,
    standardShelfLifeMonths,
  }) {
    this.id = id;
    this.tradenameName = tradenameName;
    this.chemID = chemID;
    this.substanceName = substanceName;
    this.referenceSubstance = referenceSubstance;
    this.createdByEmail = createdByEmail;
    this.createdDate = createdDate;
    this.lastModifiedByEmail = lastModifiedByEmail;
    this.lastModifiedDate = lastModifiedDate;
    this.standardShelfLifeMonths = standardShelfLifeMonths;
  }

  static async getAll(signal) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.get(`/tradename`, signal ? { signal } : undefined);

    return data.result.map((d) => new Tradename(d));
  }

  static async getByTradenameName(tradenameName) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.get(`/tradename?tradenameName=${tradenameName}`);

    return data.result.map((d) => new Tradename(d));
  }

  static async getByChemID(chemID) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.get(`/tradename/byChemID?chemID=${chemID}`);

    return data.result.map((d) => new Tradename(d));
  }

  static async update(tradename) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.put(`/tradename`, tradename);
    return data;
  }

  static async create(tradename) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.post(`/tradename`, tradename);
    return data;
  }

  static async delete(id) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.delete(`/tradename/${id}`);
    return data;
  }
}
